import * as echarts from "echarts/core"
import { BarChart, GaugeChart, LineChart, MapChart, PieChart } from "echarts/charts"
import {
  DatasetComponent,
  GeoComponent,
  GraphicComponent,
  GridComponent,
  LegendComponent,
  MarkLineComponent,
  TooltipComponent,
  VisualMapComponent,
} from "echarts/components"
import { LabelLayout } from "echarts/features"
import { CanvasRenderer } from "echarts/renderers"

let registered = false

export function ensureEchartsRegistered(): void {
  if (registered) return
  echarts.use([
    BarChart,
    LineChart,
    PieChart,
    GaugeChart,
    MapChart,
    GridComponent,
    TooltipComponent,
    LegendComponent,
    DatasetComponent,
    MarkLineComponent,
    VisualMapComponent,
    GeoComponent,
    GraphicComponent,
    LabelLayout,
    CanvasRenderer,
  ])
  registered = true
}

export { echarts }
